// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_vehicle,
  add_vehicle,
  update_vehicle,
  delete_vehicle,
  get_vehicle_list
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  vehicles: [],
  vehiclelist:[],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name:"",
    vehicle_number :"",
    vehicle_model :"",
    vehicle_quantity:"",
    year_made:"",
    driver:"",
    description:"",
    routes:"",
    route_incharge:"",
    checkout_time:"",
  },

};
// Async Thunks for API Calls
export const fetchvehiclelist = createAsyncThunk(
    'vehicletype/fetchvehiclelist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_vehicle_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

// Async Thunks for API Calls
export const fetchvehicle = createAsyncThunk(
  "vehicle/fetchvehicle",
  async (
    { page, page_size, school_id,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_vehicle(
        page,
        page_size,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createvehicle = createAsyncThunk(
  "vehicle/createvehicle",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_vehicle(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatevehicle = createAsyncThunk(
  "vehicle/updatevehicle",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_vehicle(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletevehicle = createAsyncThunk(
  "vehicle/deletevehicle",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_vehicle({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const vehicleSlice = createSlice({
  name: "vehicles",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
      EditFormData(reduxState, action) {
        reduxState.formData = { ...action.payload };
      },
    resetFormData(state) {
      state.formData = {
        name:"",
    vehicle_number :"",
    vehicle_model :"",
    vehicle_quantity:"",
    year_made:"",
    driver:"",
    description:"",
    routes:"",
    route_incharge:"",
    checkout_time:"",
      };
    },
    setvehicle(state, action) {
      state.vehicles = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchvehiclelist.fulfilled, (state, action) => {
        state.vehiclelist = action.payload.data;
      })
      .addCase(fetchvehiclelist.rejected, (state, action) => {
        state.vehiclelist = [];

      })
      // Fetch Classes
      .addCase(fetchvehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchvehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicles = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchvehicle.rejected, (state, action) => {
        state.loading = false;
        state.vehicles = [];

        state.error = action.payload;
      })

      // Add Class
      .addCase(createvehicle.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createvehicle.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createvehicle.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatevehicle.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatevehicle.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatevehicle.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deletevehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletevehicle.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletevehicle.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setvehicle,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,

} = vehicleSlice.actions;
export default vehicleSlice.reducer;
